<template>
  <HomeComponent />
</template>

<script>
// @ is an alias to /src
import HomeComponent from "@/components/Home/Home.vue";

export default {
  name: "Home",
  components: {
    HomeComponent
  }
};
</script>
